export const Ellipse = () => {
  return (
    <svg width="49" height="9" viewBox="0 0 49 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="24.5" cy="4.5" rx="24.5" ry="4.5" fill="#D9D9D9"/>
    </svg>
  )
}
